import { useState } from 'react'
import { IrregularButtonLayout } from '../../IrregularButtonLayout/IrregularButtonLayout'
import { UserCreatedProfileModal } from '../../UserCreatedProfileModal/UserCreatedProfileModal'
import { useDispatchBannerAnalyticsEvent } from '../hooks/useDispatchBannerAnalyticsEvent'
import {
  BannerContainer,
  BannerHeader,
  BannerSecondaryButton,
  BannerSubHeaderBlue,
  BannerTextBody,
  BannerTextContainer,
} from './BannerComponents'

type CustomBannerProps = {
  enableEvaluations: boolean
}

export const CustomBanner = ({ enableEvaluations }: CustomBannerProps) => {
  const [isCreationModalOpen, setIsCreationModalOpen] = useState(false)
  useDispatchBannerAnalyticsEvent('custom_inactive_create_profile')

  return (
    <BannerContainer>
      <BannerTextContainer>
        <BannerSubHeaderBlue>MARKET SPECIFIC TRANSLATIONS</BannerSubHeaderBlue>
        <BannerHeader>Tailor your content for specific target group</BannerHeader>
        <BannerTextBody>
          Create custom AI profiles for every content type. Build separate profiles for Marketing,
          Product, Legal, Support, and more—so AI uses the right examples for every translation. Set
          up in just 2 minutes and scale consistent, high-quality content with ease.
        </BannerTextBody>
      </BannerTextContainer>
      <IrregularButtonLayout>
        <BannerSecondaryButton onClick={() => setIsCreationModalOpen(true)}>
          Create content specific profile
        </BannerSecondaryButton>
      </IrregularButtonLayout>
      {isCreationModalOpen && (
        <UserCreatedProfileModal
          onClose={() => setIsCreationModalOpen(false)}
          enableEvaluations={enableEvaluations}
        />
      )}
    </BannerContainer>
  )
}
